/**
 * @flow
 * @relayHash e9c52bedac2ce14a7768a464aa1598a9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteTaskStatusMutationVariables = {|
  id: string
|};
export type DeleteTaskStatusMutationResponse = {|
  +deleteTaskStatus: {|
    +id: string
  |}
|};
export type DeleteTaskStatusMutation = {|
  variables: DeleteTaskStatusMutationVariables,
  response: DeleteTaskStatusMutationResponse,
|};
*/


/*
mutation DeleteTaskStatusMutation(
  $id: String!
) {
  deleteTaskStatus(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteTaskStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TaskStatusModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteTaskStatusMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteTaskStatusMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteTaskStatusMutation",
    "id": null,
    "text": "mutation DeleteTaskStatusMutation(\n  $id: String!\n) {\n  deleteTaskStatus(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f9c1a01d2ea4b957ea84386bb7113107';
module.exports = node;
